<template>
  <div>
    <section class="is-fullheight is-bold">
      <div class="hero-body">
        <div class="container">
          <div class="columns is-vcentered">
            <div class="column is-4 is-offset-4">
              <h1 class="title is-4">
                Login
              </h1>
              {{errorMessage}}
              <div class="box">
                <div class="field">
                  <label class="label">Email</label>
                  <p class="control">
                    <input class="input" type="text" placeholder="Enter Email" v-model="email">
                  </p>
                </div>
                <div class="field">
                  <label class="label">Password</label>
                  <p class="control">
                    <input class="input" type="password" @keyup.enter="login(email, password)" placeholder="Enter Password" v-model="password">
                  </p>
                </div>
                <hr>
                <p class="control">
                  <button @click="login(email, password)" class="button is-link">Login</button>
                  <button @click="cancel" class="button is-default">Cancel</button>
                </p>
              </div>
              <p class="has-text-centered">
                <router-link to="/register">New User?</router-link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <Footer></Footer>
  </div>
</template>

<script>
  import tenant from '@/tenant'
  import Footer from '@/Footer'
  export default {
    name: 'Login',
    data: function () {
      return {
        email: '',
        password: '',
        errorMessage: ''
      }
    },
    methods: {
      login(email, password) {
        tenant.app.auth().signInWithEmailAndPassword(email, password).then(() => {
          let param = this.$route.query['redir']
          let toPath = decodeURIComponent(param)
          if (param) {
            this.$router.push(toPath)
          } else {
            this.$router.push('/')
          }
        }).catch((error) => {
          console.log(error)
          this.errorMessage = 'Error logging in, please try again.'
        })
      },
      cancel() {
        this.$router.push('/')
      }
    },
    components: {
      Footer
    }
  }

</script>


// WEBPACK FOOTER //
// src/components/user/Login.vue?0fed145e